module.exports = __webpack_public_path__ + "images/pro/pro@2x-8a8925650f6c21642aeb685288f49141.png";